import * as JsonFormatter from 'spark-util/JsonObjectFormatter';
import get from 'lodash/get';
import filter from 'lodash/filter';
import { transform } from 'spark-util/fpUtils';
import { formatDate, formatDateTime } from 'spark-util/dateUtils';
import SafetyLetterStatus from 'spark-types/SafetyLetterStatus';

//Reducer action keys
const SET_SAFETY_LETTER_LIST = 'SAFETY_LETTER.SET_SAFETY_LETTER_LIST'; //Load safety letter initial data
const SET_COUNTRY_SUMMARY_LIST = 'SAFETY_LETTER.SET_COUNTRY_SUMMARY_LIST';
const SET_LOCAL_STUDIES_CREATE_SN = 'SAFETY_LETTER.SET_LOCAL_STUDIES_CREATE_SN';
const SET_GLOBAL_STUDIES_CREATE_SN = 'SAFETY_LETTER.SET_GLOBAL_STUDIES_CREATE_SN';
const SET_COMMENTS = 'SAFETY_LETTER. SET_COMMENTS';
const SET_RECIPIENT_COMMENTS = 'SAFETY_LETTER.SET_RECIPIENT_COMMENTS';
const SET_SAFETY_LETTER_SETTING = 'SAFETY_LETTER.SET_SAFETY_LETTER_SETTING';
const SET_SAFETY_LETTER_SETTING_CONTENT = 'SAFETY_LETTER.SET_SAFETY_LETTER_SETTING_CONTENT';
const SET_SAFETY_DETAILS_HEADER = 'SAFETY_LETTER.SET_SAFETY_DETAILS_HEADER';
const SET_SHOW_MANAGEMENT_COMMENTS_FLAG = 'SAFETY_LETTER.SET_SHOW_MANAGEMENT_COMMENTS_FLAG';
const SET_ORGANIZATION_RECIPIENTS = 'SAFETY_LETTER.SET_ORGANIZATION_RECIPIENTS';
const SET_INDIVIDUAL_RECIPIENTS = 'SAFETY_LETTER.SET_INDIVIDUAL_RECIPIENTS';
const SET_REPORT_LIST = 'SAFETY_LETTER.SET_REPORT_LIST';
const SET_ETL_FLAG = 'SAFETY_LETTER.SET_ETL_FLAG';
const SET_RECIPIENTS = 'SAFETY_LETTER.SET_RECIPIENTS';
const SET_REPORT_DATA = 'SAFETY_LETTER.SET_REPORT_DATA';
const SET_SETUP_PROGRESS = 'SAFETY_LETTER.SET_SETUP_PROGRESS';
//asarda
const CLEAR_REPORT_DATA = 'SAFETY_LETTER.CLEAR_REPORT_DATA';

//Audit Reports
const SET_AUDIT_REPORT_LIST = 'SAFETY_LETTER.SET_AUDIT_REPORT_LIST';
const SET_AUDIT_REPORT_DATA = 'SAFETY_LETTER.SET_AUDIT_REPORT_DATA';
const CLEAR_AUDIT_REPORT_DATA = 'SAFETY_LETTER.CLEAR_AUDIT_REPORT_DATA';
//end

//Overdue Acknowledgment management
const SET_SAFETY_NOTIFICATIONS_FOR_OVERDUE_ACK = 'SAFETY_LETTER.SET_SAFETY_NOTIFICATIONS_FOR_OVERDUE_ACK'; 
const SET_OVERDUE_ACK_RESULTS_GRID = 'SAFETY_LETTER.SET_OVERDUE_ACK_RESULTS_GRID';
const SET_OVERDUE_ACK_FILTERS = 'SAFETY_LETTER.SET_OVERDUE_ACK_FILTERS';
const DISPLAY_OVERDUE_ACK_GRID_HEADER_CHECKBOX = 'SAFETY_LETTER.DISPLAY_OVERDUE_ACK_GRID_HEADER_CHECKBOX';
const SET_ACK_STATUS_FILTER_OPTIONS ='SAFETY_LETTER.SET_ACK_STATUS_FILTER_OPTIONS';
const setSafetyLetterSetting = (setting) => (value) => ({
	type: SET_SAFETY_LETTER_SETTING,
	setting,
	value
});

// Sn drafts
const SET_SAFETY_LETTER_DRAFT_LIST = 'SAFETY_LETTER.SET_SAFETY_LETTER_DRAFT_LIST'; 

//Manage Roles
const SET_ROLE_LIST = 'SAFETY_LETTER.SET_ROLE_LIST';
const SET_ORG_TYPE_LIST =  'SAFETY_LETTER.SET_ORG_TYPE_LIST';

const SET_FILE_PREVIEW_DETAILS = 'SAFETY_LETTER.SET_FILE_PREVIEW_DETAILS';
//To Save study Specific File Name in redux state
const SET_STUDY_FILE_NAME_DETAILS = 'SAFETY_LETTER.SET_STUDY_FILE_NAME_DETAILS';

//Action creators
// SAF-18351 Set file preview details to redux state
export const setPreviewDocValues = (safetyId, response) => ({ type: SET_FILE_PREVIEW_DETAILS, safetyId, response });
export const setStudyFileNameValue = (safetyId, fileName, studyName) => ({ type: SET_STUDY_FILE_NAME_DETAILS, safetyId, fileName, studyName });

export const setSafetyNotifications = (response) => ({ type: SET_SAFETY_LETTER_LIST, response });

export const setSafetyHeader = (safetyId, details) => ({
	type: SET_SAFETY_DETAILS_HEADER,
	safetyId,
	details
});
export const setShowManagementCommentsFlag = (safetyId, showManagementCommentsFlag) => ({
	type: SET_SHOW_MANAGEMENT_COMMENTS_FLAG,
	safetyId,
	showManagementCommentsFlag
});
export const setCountrySummary = (safetyId, countries) => ({
	type: SET_COUNTRY_SUMMARY_LIST,
	safetyId,
	countries
});

export const setLocalStudiesCreatSN = (response) => ({
	type: SET_LOCAL_STUDIES_CREATE_SN,
	response
}); 

export const setGlobalStudiesCreatSN = (response) => ({
	type: SET_GLOBAL_STUDIES_CREATE_SN,
	response
});

export const setComments = (safetyId, comments) => ({
	type: SET_COMMENTS,
	safetyId,
	comments
});

export const setRecipientComments = (safetyId, data) => ({
	type: SET_RECIPIENT_COMMENTS,
	safetyId,
	comments: get(data,"getReciAckComments.content"),
	displayComments:  data.displayComments
});

export const setEtlFlag = (safetyId) => ({
	type: SET_ETL_FLAG,
	safetyId
});
export const setOrganizationRecipients = (safetyId, recipients = [], allDownloaded = false) => ({
	type: SET_ORGANIZATION_RECIPIENTS,
	safetyId,
	recipients,
	allDownloaded
});

export const setIndividualRecipients = (safetyId, safetyOrgId, recipients) => ({
	type: SET_INDIVIDUAL_RECIPIENTS,
	safetyId,
	safetyOrgId,
	recipients
});

export const setRecipients = (safetyId, recipients = []) => ({
	type: SET_RECIPIENTS,
	safetyId,
	recipients
});

export const setSetupProgressFlag = (status) => ({
	type: SET_SETUP_PROGRESS,
	status
});

const responseAction = (actionName) => (response) => ({
	type: actionName,
	response
});

export const setReportFormData = (response) => ({
	type: SET_REPORT_DATA,
	response
});

//asarda
export const clearReportData = () => ({
	type: CLEAR_REPORT_DATA,
});
//end

//Audit Reports
export const setAuditReportFormData = (response) => ({
	type: SET_AUDIT_REPORT_DATA,
	response
});

export const clearAuditReportData = () => ({
	type: CLEAR_AUDIT_REPORT_DATA,
});

export const setVersion = setSafetyLetterSetting('version');
export const setMolecule = setSafetyLetterSetting('molecule');
export const setReportList = responseAction(SET_REPORT_LIST);
//Audit Reports
export const setAuditReportList = responseAction(SET_AUDIT_REPORT_LIST);

//Overdue Acknowledgement
export const setSafetyNotificationsforOverdueAck = (response) => ({
	type: SET_SAFETY_NOTIFICATIONS_FOR_OVERDUE_ACK,
	response
})
export const setOverdueAckResultsGrid = (status) => ({
	type:SET_OVERDUE_ACK_RESULTS_GRID,
	status
})
export const setOverdueAckFilters = (filters) => ({
	type: SET_OVERDUE_ACK_FILTERS,
	filters
})
export const setOverdueAckGridHeaderCheckbox = (status)=>({
	type: DISPLAY_OVERDUE_ACK_GRID_HEADER_CHECKBOX,
	status
})
export const setAckStatusFilterOptions = (response) => ({
	type: SET_ACK_STATUS_FILTER_OPTIONS,
	response
})

//SN drafts
export const setSafetyNotificationDrafts = (response) => ({ type: SET_SAFETY_LETTER_DRAFT_LIST, response });

//Manage Roles
export const setRoleList = (response) => ({ type: SET_ROLE_LIST, response });
export const setOrgTypeList = (response) => ({ type: SET_ORG_TYPE_LIST, response });

//Redux state exposers
export const getNotificationById = (state, id) => get(state, `safetyLetter.notifications[${id}]`);

export const getNotificationRecipientsById = (state, safetyId, slOrgId) =>
	get(state, `safetyLetter.organizationRecipients[${safetyId}][${slOrgId}]`);

export const getIndividualRecipient = (state, safetyId, safetyOrgId, index) =>
	get(state, `safetyLetter.individualRecipients[${getIndividualRecipientKey(safetyId, safetyOrgId)}][${index}]`);

export const getRecipientsById = (state, safetyId, slOrgId) =>
	get(state, `safetyLetter.recipients[${safetyId}][${slOrgId}]`);

export const getCommentById = (state, safetyId, safetyEventsId) =>
	get(state, `safetyLetter.comments[${safetyId}][${safetyEventsId}]`);

//To display Recipient Acknowledgement Comments in UI
export const getRecipientCommentById = (state, rowId) =>
	get(state, `safetyLetter.recipientComments[${rowId}]`);

export const getDisplayReciAckComments = (state) => state.safetyLetter.displayReciAckComments;
export const getSafetyLetterSetting = (state, setting) => state.safetyLetter.settings[setting];
export const getReportList = (state) => state.safetyLetter.reportList;
export const getReportData = (state) => state.safetyLetter.reportData;
export const getSpecificReportList = (state, value) => {
	const reportList = JsonFormatter.arrayToObject('rptTypeVal', state.safetyLetter.reportList.map(formatSafetyLetter));
	return reportList[value];
};

//Audit Reports
export const getAuditReportList = (state) => state.safetyLetter.auditReportList;
export const getAuditReportData = (state) => state.safetyLetter.auditReportData;
export const getSpecificAuditReportList = (state, value) => {
	const auditReportList = JsonFormatter.arrayToObject('rptTypeVal', state.safetyLetter.auditReportList.map(formatSafetyLetter));
	return auditReportList[value];
};

export const getSelectedEnterprise = (state) => state.user.enterpriseId;

export const getCountryById = (state, safetyId, safetyCountryId) =>
	get(state, `safetyLetter.countries[${safetyId}][${safetyCountryId}]`);

export const getGlobalStudyById = (state, uuid) =>
	get(state, `safetyLetter.globalStudies[${uuid}]`);

export const getLocalStudyById = (state, uuid) =>
	get(state, `safetyLetter.localStudies[${uuid}]`);

export const getCountryIso = (state, safetyId, safetyCountryId) =>
	get(getCountryById(state, safetyId, safetyCountryId), 'countryIso');

export const getSafetyLetterFilename = (state, safetyId) => {
	const safetyLetter = getNotificationById(state, safetyId);
	return safetyLetter ? safetyLetter.fileName : '';
};
//To fetch Study File Name
export const getStudyFileName = (state, safetyId) => {
	const safetyLetter = getNotificationById(state, safetyId);
	return safetyLetter ? safetyLetter.studyFileName : '';
};
//To enable Ack button when all study file are downloaded
export const getAlldownloadedFlag = (state, safetyId) => get(state, `safetyLetter.allDownloaded[${safetyId}]`);
export const getCountries = (state, safetyId) => get(state, `safetyLetter.countries[${safetyId}]`);

export const isSafetyLetterDisabled = (state, id) =>
	SafetyLetterStatus(get(state, `safetyLetter.notifications[${id}].status`)).isDisabled();
export const hasFile = (state, id) => get(state, `safetyLetter.notifications[${id}].fileName`);

const getIndividualRecipientKey = (safetyId, safetyOrgId) => `${safetyId}-${safetyOrgId}`;
export const getReportsList = (state) => state.safetyLetter.reports;
export const getAuditReportsList = (state) => state.safetyLetter.auditReports;

export const setSelectedCountriesByIds = (state, safetyId) => (selectedCountries, params) =>
	CountrysummaryActionsFormattedData(
		selectedCountries.map((safetyCountryId) => getCountryById(state, safetyId, safetyCountryId)),
		params
	);

export const getCountryActionStatus = (state, gridName) => get(state, `grid[${gridName}].qualifiedCountries`);

export const getSetupStatus = (state) => state.safetyLetter.isSetupProgress;

const CountrysummaryActionsFormattedData = (data, params) => {
	const qualifiedCountries = filter(data, [ 'status', params.valid ]);
	const distributAndDoNotDistributeCountries = data.filter(
		(country) => country.status === 'Distributed' || country.status === 'Not Distributed'
	);
	const notQualifiedCountries = filter(data, [ 'status', params.Invalid ]);
	return {
		qualifiedCountries,
		notQualifiedCountries,
		distributAndDoNotDistributeCountries
	};
};

export const getSafetyCountryIds = (state, gridName) => get(state, `grid[${gridName}].order`);

export const getStudyIds = (state, gridName) => get(state, `grid[${gridName}].order`);

export const getStudiesTotalElements = (state, gridName) => get(state, `grid[${gridName}].totalElements`);


export const getBulkDownloadNotifications = (state) => state.safetyLetter.notifications;

//Overdue Acknowledgement Management
export const getOverdueAckFilters = (state) => state.safetyLetter.overdueAckFilters || {};
export const getOverdueAckResultsGrid = (state) => state.safetyLetter.displayOverdueAckResultsGrid;
export const getSafetyNotificationsforOverdueAck = (state) => state.safetyLetter.safetyNotificationsforOverdueAck;
export const getSNforOverdueAckById = (state, id) => get(state, `safetyLetter.safetyNotificationsforOverdueAck[${id}]`);
export const getOverdueAckGridHeaderCheckbox = (state) => state.safetyLetter.displayOverdueAckGridHeaderCheckbox;
export const getAckStatusFilterOptions = (state) => state.safetyLetter.ackStatusFilterOptions;
//SN drafts
export const getSnDraftById = (state, id) => get(state, `safetyLetter.snDrafts[${id}]`);

//Manage Roles
export const getRolesById = (state, id) => get(state, `safetyLetter.roleList[${id}]`);
export const getOrgTypeList = (state) => get(state, `safetyLetter.orgTypeList` );

// Initial component state
const initialState = {
	notifications: {},
	organizationRecipients: {
		//[safetyId]: orgRecipients
	},
	recipients: {
		//[safetyId]: Recipients
	},
	individualRecipients: {
		//["safetyId-safetyOrgId"]: recipients
	},
	countries: {
		//[safetyId]: countries
	},
	comments: {
		//[safetyId]: comments
	},
	recipientComments: {
		//[safetyId]: comments
	},
	settings: {
		version: [],
		molecule: []
	},
	countryKeys: {},
	reportList: [],
	reportData: {},
	//Audit Reports
	auditReportList: [],
	auditReportData: {},

	isSetupProgress: false,
	studies: {},
	displayOverdueAckResultsGrid: false,
	overdueAckFilters: {},
	safetyNotificationsforOverdueAck: [],
	displayOverdueAckGridHeaderCheckbox: false,
	ackStatusFilterOptions: [],
	displayReciAckComments: false,
	snDrafts: [],
	roleList: [],
	orgTypeList: []
};

export const reducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_SAFETY_LETTER_LIST: {
			return {
				...state,
				notifications: JsonFormatter.arrayToObject(
					'safetyId',
					get(action.response, 'data.content', []).map(formatSafetyLetter)
				)
			};
		}

		case SET_SAFETY_DETAILS_HEADER: {
			const notification = state.notifications[action.safetyId];
			return {
				...state,
				notifications: {
					...state.notifications,
					[action.safetyId]: formatSafetyLetter({
						...notification,
						...action.details
					})
				}
			};
		}

		case SET_SHOW_MANAGEMENT_COMMENTS_FLAG: {
			const notification = state.notifications[action.safetyId];
			return {
				...state,
				notifications: {
					...state.notifications,
					[action.safetyId]: formatSafetyLetter({
						...notification,
						showManagementCommentsFlag: action.showManagementCommentsFlag
					})
				}
			};
		}

		case SET_ORGANIZATION_RECIPIENTS: {
			return {
				...state,
				organizationRecipients: {
					[action.safetyId]: JsonFormatter.arrayToObject(
						'safetyOrgId',
						action.recipients.map(formatOrganizationDates)
					)
				},
				allDownloaded: {[action.safetyId]: action.allDownloaded}
			};
		}

		case SET_RECIPIENTS: {
			return {
				...state,
				recipients: {
					[action.safetyId]: JsonFormatter.arrayToObject(
						'uniqueKeyForOrgUser',
						action.recipients.map(formatRecipientDates)
					)
				}
			};
		}
		case SET_INDIVIDUAL_RECIPIENTS: {
			const { safetyId, safetyOrgId } = action;
			const key = getIndividualRecipientKey(safetyId, safetyOrgId);

			return {
				...state,
				individualRecipients: {
					[key]: action.recipients.map(formatRecipientDates)
				}
			};
		}
		case SET_COUNTRY_SUMMARY_LIST: {
			let countries = {
				[action.safetyId]: {
					...JsonFormatter.arrayToObject(
						'safetyCountryId',
						(action.countries || []).map(formatCountrySummaryDates)
					)
				}
			};
			return {
				...state,
				countries
			};
		}
		case SET_COMMENTS: {
			return {
				...state,
				comments: {
					[action.safetyId]: JsonFormatter.arrayToObject(
						'slMngtEventId',
						(action.comments || []).map(formatCommentDates)
					)
				}
			};
		}
		case SET_RECIPIENT_COMMENTS: {
			return {
				...state,
				displayReciAckComments: action.displayComments,
				recipientComments: (action.comments || []).map(formatRecipientCommentDates)
			};
		}
		case SET_LOCAL_STUDIES_CREATE_SN: {
			return {
				...state,
				localStudies: action.response.data ? JsonFormatter.arrayToObject(
					'uuid',
					get(action.response, 'data', [])
				) : []
			};
		}
		case SET_GLOBAL_STUDIES_CREATE_SN: {
			return {
				...state,
				globalStudies: action.response.data ? JsonFormatter.arrayToObject(
					'uuid',
					get(action.response, 'data', [])
				) : []
			};
		}
		case SET_SAFETY_LETTER_SETTING: {
			return Object.assign({}, state, {
				settings: {
					...state.settings,
					[action.setting]: action.value.data
				}
			});
		}
		case SET_SAFETY_LETTER_SETTING_CONTENT: {
			return Object.assign({}, state, {
				settings: {
					...state.settings,
					[action.setting]: action.value.data.content
				}
			});
		}
		case SET_REPORT_LIST: {
			return {
				...state,
				reportList: get(action, 'response.data')
			};
		}
		case SET_REPORT_DATA: {
			return {
				...state,
				reportData: action.response
			};
		}
		//asarda
		case CLEAR_REPORT_DATA: {
			return {
				...state,
				reportData: {}
			};
		}

		//Audit Reports
		case SET_AUDIT_REPORT_LIST: {
			return {
				...state,
				auditReportList: get(action, 'response.data')
			};
		}
		case SET_AUDIT_REPORT_DATA: {
			return {
				...state,
				auditReportData: action.response
			};
		}
		//asarda
		case CLEAR_AUDIT_REPORT_DATA: {
			return {
				...state,
				auditReportData: {}
			};
		}

		//end
		case SET_ETL_FLAG: {
			const notification = state.notifications[action.safetyId];
			return {
				...state,
				notifications: {
					...state.notifications,
					[action.safetyId]: formatSafetyLetter({
						...notification,
						...(notification.etlFlg = 'P')
					})
				}
			};
		} 
		case SET_SETUP_PROGRESS: {
			return {
				...state,
				isSetupProgress: action.status
			};
		}
		//Overdue Acknowledgement management
		case SET_OVERDUE_ACK_RESULTS_GRID: {
			return {
				...state,
				displayOverdueAckResultsGrid: action.status
			};
		}
		case SET_OVERDUE_ACK_FILTERS: {
			return {
				...state,
				overdueAckFilters: action.filters || {}
			};
		}
		case SET_SAFETY_NOTIFICATIONS_FOR_OVERDUE_ACK: {
			return {
				...state,
				safetyNotificationsforOverdueAck: get(action.response, 'data.content', [])
			};
		}
		case DISPLAY_OVERDUE_ACK_GRID_HEADER_CHECKBOX: {
			return{
				...state,
				displayOverdueAckGridHeaderCheckbox: action.status
			};
		}
		case SET_ACK_STATUS_FILTER_OPTIONS: {
			return{
				...state,
				ackStatusFilterOptions: get(action, 'response.data' )
			};
		}
		case SET_SAFETY_LETTER_DRAFT_LIST: {
			return {
				...state,
				snDrafts: JsonFormatter.arrayToObject(
					'safetyId',
					get(action.response, 'data.content', []).map(formatSafetyLetter)
				)
			};
		}
		//Manage Roles
		case SET_ROLE_LIST: {
			return {
				...state,
				roleList: get(action.response, 'data.content', [])

			}
		}
		case SET_ORG_TYPE_LIST: {
			return {
				...state,
				orgTypeList: get(action.response, 'data', [])
			}
		}
		case SET_FILE_PREVIEW_DETAILS: {
			const notification = state.notifications[action.safetyId];
			return {
				...state,
				notifications: {
					...state.notifications,
					[action.safetyId]: formatSafetyLetter({
						...notification,
						fileDetails: get(action.response, 'data', []),
						loading: true
					})
				}
			};
		}
		case SET_STUDY_FILE_NAME_DETAILS: {
			const { safetyId, fileName, studyName } = action;
			const notification = state.notifications[safetyId];
			return {
				...state,
				notifications: {
					...state.notifications,
					[safetyId]: formatSafetyLetter({
						...notification,
						studyFileName: fileName,
						studyName: studyName,
						loading: true
					})
				}
			};
			
		}
		default:
			return state;
	}
};

const formatSafetyLetter = transform({
	molecules: (moleculeList = '') => moleculeList.replace(/;/g, ', '),
	distDueDate: formatDate, // distDueDate is  due date for details
	ackDueDate: formatDate,
	dayZeroDate: formatDate,
	createdDate: formatDate,
	uploadDueDate: formatDate,
	safetyCutOffDate: formatDate //SAF-18080 added Date formatting for Safety Cut Off Date
});

const formatCountrySummaryDates = transform({
	statusDate: formatDate
});
//SAF-20546-Visibility of Comments Across all the Users - removed fromatting for ackDate as it is used twice 1. only date in grid and 2. date time in view ack comments popup - fomatting is done at component level based on the usage. 
const formatOrganizationDates = transform({
	notifiedDate: formatDate
});
const formatCommentDates = transform({
	createdDate: formatDateTime
});
const formatRecipientCommentDates = transform({
	ackDate: formatDateTime
});
const formatRecipientDates = transform({
	createdDt: formatDate,
	endDate: formatDate,
	notifyDate: formatDate
});
